import React, { useState } from 'react'
import styled from 'styled-components'
import { Tablet, MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import Container from '~shared/Container'
import Gallery, { slideIndex } from '~shared/Gallery'
import { Link } from 'gatsby'
import urls from '~utils/urls'
import Topic from '~shared/Topic'
import ButtonWrapper from '~shared/ButtonWrapper'
import CaseStudy from '~shared/CaseStudy'
import PrestyledSliderNav from '~shared/SliderNav'
import Display from '~shared/Display'
import Spacer from '~shared/Spacer'
import DangerousHtml from '~shared/DangerousHtml'
import useTranslation from '~utils/useTranslation'
import SocialImageTracey from '~shared/../CaseStudies/Tracey/SocialImage'
import SocialImageSwash from '~shared/../CaseStudies/Swash/SocialImage'
import SocialImageMachineWitness from '~shared/../CaseStudies/MachineWitness/SocialImage'
import SocialImagePaveMotors from '~shared/../CaseStudies/PaveMotors/SocialImage'
import { OutlinedButton, Size } from 'streamr-ui/Button'

const Content = styled.div`
    margin-top: 48px;

    @media ${MqDesktop} {
        margin-top: 112px;
    }
`

const ContentInner = styled.div`
    @media ${MqDesktop} {
        padding: 0 48px;
    }
`

const Studies = styled.div`
    position: relative;

    ${OutlinedButton} {
        margin-top: 2.5rem;
        margin-bottom: 4px;
    }
`

const SlideContainer = styled(Container)`
    @media (max-width: ${Tablet - 1}px) {
        padding: 0;
    }
`

const SliderNav = styled(PrestyledSliderNav)`
    margin: 0 auto;
`

function StudyItem({ href = '#', active = false, children }) {
    return active
        ? <a href={href}>{children}</a>
        : <span>{children}</span>
}

const UnstyledCaseStudies = (props) => {
    const [slide, setSlide] = useState(0)

    const index = slideIndex(slide, 4)

    const { t } = useTranslation()

    return (
        <div {...props}>
            <SlideContainer>
                <Gallery
                    slide={slide}
                    onChange={setSlide}
                >
                    <StudyItem active={index !== 0} href={urls.caseStudies.paveMotors}>
                        <Gallery.Item as="div" disabled={index !== 0}>
                            <SocialImagePaveMotors />
                        </Gallery.Item>
                    </StudyItem>
                    <StudyItem active={index !== 1} href={urls.caseStudies.swash}>
                        <Gallery.Item as="div" disabled={index !== 1}>
                            <SocialImageSwash />
                        </Gallery.Item>
                    </StudyItem>
                    <StudyItem active={index !== 2} href={urls.caseStudies.tracey}>
                        <Gallery.Item as="div" disabled={index !== 2}>
                            <SocialImageTracey />
                        </Gallery.Item>
                    </StudyItem>
                    <StudyItem active={index !== 3} href={urls.caseStudies.machineWitness}>
                        <Gallery.Item as="div" disabled={index !== 3}>
                            <SocialImageMachineWitness />
                        </Gallery.Item>
                    </StudyItem>
                </Gallery>
            </SlideContainer>
            <Container>
                <Content>
                    <ContentInner>
                        <Studies>
                            <CaseStudy
                                name="Pave Motors"
                                active={index === 0}
                            >
                                <DangerousHtml tag={Topic.Paragraph} $appear>
                                    {t('caseStudy.paveMotors.desc')}
                                </DangerousHtml>
                                <ButtonWrapper>
                                    <OutlinedButton
                                        tag={Link}
                                        to={urls.caseStudies.paveMotors}
                                        size={Size.Moose}
                                    >
                                        {t('caseStudy.readMore')}
                                    </OutlinedButton>
                                </ButtonWrapper>
                            </CaseStudy>
                            <CaseStudy
                                name="Swash"
                                active={index === 1}
                            >
                                <DangerousHtml tag={Topic.Paragraph} $appear>
                                    {t('caseStudy.swash.desc')}
                                </DangerousHtml>
                                <ButtonWrapper>
                                    <OutlinedButton
                                        tag={Link}
                                        to={urls.caseStudies.swash}
                                        size={Size.Moose}
                                    >
                                        {t('caseStudy.readMore')}
                                    </OutlinedButton>
                                </ButtonWrapper>
                            </CaseStudy>
                            <CaseStudy
                                name="Tracey"
                                active={index === 2}
                            >
                                <DangerousHtml tag={Topic.Paragraph} $appear>
                                    {t('caseStudy.tracey.desc')}
                                </DangerousHtml>
                                <ButtonWrapper>
                                    <OutlinedButton
                                        tag={Link}
                                        to={urls.caseStudies.tracey}
                                        size={Size.Moose}
                                    >
                                        {t('caseStudy.readMore')}
                                    </OutlinedButton>
                                </ButtonWrapper>
                            </CaseStudy>
                            <CaseStudy
                                name="Machine Witness"
                                active={index === 3}
                            >
                                <DangerousHtml tag={Topic.Paragraph} $appear>
                                    {t('caseStudy.machineWitness.desc')}
                                </DangerousHtml>
                                <ButtonWrapper>
                                    <OutlinedButton
                                        tag={Link}
                                        to={urls.caseStudies.machineWitness}
                                        size={Size.Moose}
                                    >
                                        {t('caseStudy.readMore')}
                                    </OutlinedButton>
                                </ButtonWrapper>
                            </CaseStudy>
                        </Studies>
                    </ContentInner>
                </Content>
                <Display as={Spacer} mobile="block" tablet="none" head="4.5rem">
                    <SliderNav
                        current={index}
                        size={4}
                        onChange={setSlide}
                        theme={SliderNav.WhiteTheme}
                    />
                </Display>
            </Container>
        </div>
    )
}

const CaseStudies = styled(UnstyledCaseStudies)`
    overflow: hidden;

    ${Content},
    ${Gallery.SlideContainer} {
        padding: 0;

        @media ${MqTablet} {
            padding: 0 24px;
        }

        @media ${MqDesktop} {
            padding: 0 48px;
        }
    }
`

export default CaseStudies
